<p-toast></p-toast>
<p-dialog [(visible)]="newChatModal" header="{{ 'CHAT_TITLE_NEW_CHAT' | translate}}" 
  [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '30vw'}" [modal]="true">
  <app-newchatmodalcomp *ngIf="newChatModal" (ncModal)="newChatsModal()" (mostrarMensaje)="mostrarMensaje($event)"></app-newchatmodalcomp>
</p-dialog>


<p-sidebar [(visible)]="rightSideBar" position="right" [baseZIndex]="10000">
    <app-right-side-bar-comp></app-right-side-bar-comp>
</p-sidebar>

<div class="p-grid mw-100 ns" style="position: fixed;">
    <div class="p-col-12 p-md-4 p-lg-4 chat-column" (scroll)="onScroll()" #chatsContainer>
        <div class="pd-15">
            <app-chatheaderwincomp [sh]="sh" [dev]="dev" (connModal)="openCon()" (setModal)="settingModal()"
                (nchatModal)="newChatsModal()" (devModal)="showDevice()" (searchModal)="openSearch()">
            </app-chatheaderwincomp>
        </div>
        <div *ngIf="dev===true" style="margin-bottom:20px;overflow-y: auto;height: 4rem;">
            <app-moredevcomp (eModal)="editssModal()" (rModal)="rebootsModal()"></app-moredevcomp>
        </div>
        <div *ngIf="search===true" class="row pd-15">
            <span class="p-input-icon-left custMSearch">
                <i class="pi pi-search"></i>
                <input class="custIMSearch" type="text" pInputText
                placeholder="{{ placeholderText }}"
                [(ngModel)]="term" (focus)="onSearchInputFocus()" (blur)="onSearchInputBlur()"
                (keyup.enter)="searchChats()" (keyup)="onSearchInputChange($event)" />
            
                <i class="pi pi-times icnCstColor"  (click)="openSearch()"></i>
            </span>
        </div>
        <div class="estilo" [ngClass]="sh?'shc':'nshc'">
            <app-panelcompchat ></app-panelcompchat>
        </div>
        <div [ngClass]="sh?'nshc':'shc'">
            <app-contablecomp></app-contablecomp>
        </div>
        <div style="display: flex; align-items: center; justify-content: center;" *ngIf="loadingMessages" class="loading-indicator">
            <p-progressSpinner [style]="{'width':'40px', 'height':'40px'}"></p-progressSpinner>
            <p [style]="{'width':'40px', 'height':'40px'}"> {{ 'CHAT_LOADING' | translate}} </p>
        </div>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8 customBGC">
        <app-message-screen (rightSideBar)="rightSB()"></app-message-screen>
    </div>
</div>

<div [ngClass]="schat?'nshc':'emsg'">
    <div class="p-grid mw-100">
        <div class="p-col-12 p-md-12 p-lg-12">
            <div class="pd-15">
                <app-chatheaderwincomp *ngIf="schat" [sh]="sh" [dev]="dev" (connModal)="openCon()" (setModal)="settingModal()"
                    (nchatModal)="newChatsModal()" (devModal)="showDevice()" (searchModal)="openSearch()">
                </app-chatheaderwincomp>
            </div>

            <div *ngIf="schat && dev===true" style="margin-bottom:20px">
                <app-moredevcomp (eModal)="editssModal()" (rModal)="rebootsModal()"> </app-moredevcomp>
            </div>

            <div *ngIf="search===true" class="row pd-15">
                <span class="p-input-icon-left custMSearch">
                    <i class="pi pi-search"></i>
                    <input class="custIMSearch" type="text" pInputText
                    placeholder="{{ placeholderText }}"
                    [(ngModel)]="term" (focus)="onSearchInputFocus()" (blur)="onSearchInputBlur()"
                    (keyup.enter)="searchChats()" (keyup)="onSearchInputChange($event)" />
                
             
                </span>
            </div>
            <div [ngClass]="sh?'shc':'nshc'" *ngIf="schat">
                <app-panelsmallscreencompchat  (smsChat)="changeSh()"></app-panelsmallscreencompchat>
            </div>
            <div [ngClass]="sh?'nshc':'shc'">
                <app-contablecomp></app-contablecomp>
            </div>
        </div>
    </div>
</div>

<div [ngClass]="schat?'shc':'nshc'">
    <div class="p-grid mw-100">
        <div class="p-col-12 p-md-12 p-lg-12 customBGC">
            <div class="row mbmlmt">
                <button pButton pRipple type="button" label="Back" icon="pi pi-times"
                    class="p-button-raised p-button-secondary p-button-text" (click)="backSh()">
                </button>
            </div>
            <app-message-screen *ngIf="schat" (rightSideBar)="rightSB()"></app-message-screen>
        </div>
    </div>
</div>